/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/


import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**
 * @export
 * @class LmsLoggerService
 */
@Injectable()
export class LmsLoggerService {

    date: Date;
    data: any;

    /**
     * Creates an instance of LmsLoggerService.
     * @param {HttpClient} httpClient
     * @param {Router} router
     *
     * @memberOf LmsLoggerService
     */
    constructor(private http: HttpClient,
        private router: Router) {
        this.getLoggerResponse();
    }

    /**
     * This method gets response from Logger.jason
     * @memberOf LmsLoggerService
     */
    getLoggerResponse() {

        this.http.get(`data/logger.json`)
            .subscribe(data => {
                this.data = data;
            });
    }

    /**
     * Logs Data when logger type is Info
     * @param {string} functioName
     * @param {any} args
     * @memberOf LmsLoggerService
     */
    logInfo(functioName: string, ...args) {
        if (this.data && this.data.log.level.info) {
            this.date = new Date();
            console.log('INFO >>>>', functioName, this.getCurrentDateTime(this.date), args);
        }
    }

    /**
     * Logs Data when logger type is Error
     * @param {string} functioName
     * @param {any} args
     * @memberOf LmsLoggerService
     */
    logError(functioName: string, ...args) {
        if (this.data && this.data.log.level.error) {
            this.date = new Date();
            console.log('ERROR >>>>', functioName, this.getCurrentDateTime(this.date), args);
        }
    }

    /**
     * Logs Data when logger type is Debug
     * @param {string} functioName
     * @param {any} args
     * @memberOf LmsLoggerService
     */
    logDebug(functioName: string, ...args) {
        if (this.data && this.data.log.level.debug) {
            this.date = new Date();
            console.log('DEBUG >>>>', functioName, this.getCurrentDateTime(this.date), args);
        }
    }

    /**
     * Logs Data when logger type is Warning
     * @param {string} functioName
     * @param {any} args
     * @memberOf LmsLoggerService
     */
    logWarn(functioName: string, ...args) {
        if (this.data && this.data.log.level.warn) {
            this.date = new Date();
            console.log('WARNING >>>>', functioName, this.getCurrentDateTime(this.date), args);
        }
    }

    /**
     * Calculate Current Time
     * @param {Date} date
     * @returns {string}
     * @memberOf LmsLoggerService
     */
    getCurrentDateTime(date: Date): string {
        return date.getMonth() + 1 + '/' +
            date.getDate() + '/' + date.getFullYear() + ' '
            + date.getHours() + ':' + date.getMinutes() + ':'
            + date.getSeconds();
    }

}
